import Service from './Service';

class NativeKeyboard extends Service {
  size = 0;
  updateSize(size) {
    if (size > 0) {
      const active = document.activeElement;
      if (active) {
        active.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    document.body.style.caretColor = 'transparent';
    setTimeout(() => {
      document.body.style.removeProperty('caret-color');
    }, 300);
    this.size = -size;
    this.emitStateUpdate();
  }
}
const singleton = new NativeKeyboard();
export default singleton;
